export enum JourneyStatusEnum {
  DRAFT = "draft",
  ACTIVE = "active",
  ON_HOLD = "onhold",
  COMPLETED = "completed",
}
